<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center">
			<div v-if="contentBlocksContent.length">
				<h2 class="subtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div v-for="(block, index) in items" :key="block.ID" class="row contentblock">
			<div class="row contentblock">
				<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
					<div class="content-wrap">
						<h2>{{ block.header }}</h2>
						<div v-parse-links v-html="block.content" />
					</div>
				</div>
				<div class="contentblock-image">
					<picture>
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: $contentblock-background-color;
}

.background-light {
	background: $alternating-background-color;
}

.contentblock {
	margin: 40px auto;
	position: relative;
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 62%;
	z-index: 1;
}

.contentblock-content {
	margin: 60px 30px 60px 0;
	position: relative;
	z-index: 2;
	width: 46%;

	.content-wrap {
		z-index: 4;
		position: relative;
		width: 100%;
		height: 100%;
		background: #fff;
		padding: 70px;
		box-shadow: 0 18px 18px rgb(0 0 0 / 25%);
	}

	&::after {
		content: '';
		display: block;
		position: absolute;
		inset: 30px -20px -30px 40px;
		background: rgb(135 158 142 / 90%);
		box-shadow: 0 18px 18px rgb(0 0 0 / 25%);
		backdrop-filter: blur(17px);
		z-index: 3;
	}
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.contentblock-image {
		position: relative;
		inset: auto;
		width: calc(100% - 40px);
		margin: 0 auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
	}

	.contentblock-content {
		margin: 0 auto 50px;
		padding: 0;
		width: calc(100% - 40px);

		.content-wrap {
			padding: 50px 30px;
			box-shadow: 0 9px 9px rgb(0 0 0 / 25%);
		}

		&::after {
			box-shadow: 0 9px 9px rgb(0 0 0 / 25%);
		}
	}
}
</style>
